module.exports = __webpack_public_path__ + "static/GTAmerica-LightItalic-ec27e98fa39bdf9c91dd5f2d67e71934.woff";